<div class="blob-wrapper">

  <svg #svgElement width="24" height="24" viewBox="0 0 500 500">
    <defs>
      <radialGradient id="gradient1" cx="50%" cy="50%" r="50%">
        <stop offset="0%" style="stop-color:#ff6f61;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#ff6f61;stop-opacity:0" />
      </radialGradient>
      <radialGradient id="gradient2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" style="stop-color:#6b5b95;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#6b5b95;stop-opacity:0" />
      </radialGradient>
      <radialGradient id="gradient3" cx="50%" cy="50%" r="50%">
        <stop offset="0%" style="stop-color:#88b04b;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#88b04b;stop-opacity:0" />
      </radialGradient>
      <radialGradient id="gradient4" cx="50%" cy="50%" r="50%">
        <stop offset="0%" style="stop-color:#f7d55b;stop-opacity:1" />
        <stop offset="100%" style="stop-color:#f7d55b;stop-opacity:0" />
      </radialGradient>
    </defs>
  </svg>

  <div class="circle-one"></div>
  <div #circle class="circle-two" [ngClass]="{ 'is-user' : isUser}"></div>

</div>